/**
 * RiskGraph component module.
 * @module shared/components/RiskGraph
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import Pie, {colorRender} from '../../../../shared/components/graphs/Pie';
import {_openModal} from '../../../../shared/reducers/modals';
import {connect} from 'react-redux';
import useSWR from 'swr';
import history from '../../../../history';
import useQueryObject from '../../../../shared/utils/useQueryObject';
import {LoadingSpinner} from '../../../../shared';
import Row from '../../../../shared/components/Row';
import {withTheme} from 'styled-components/macro';
import {buildQueryContext} from '../../../../shared/utils/utils';

const RiskGraph = ({containerID, theme}) => {
  const [context] = useQueryObject('context');

  const {data} = useSWR(containerID && `/containers/${containerID}/riskalerts/count`);
  const formattedData = React.useMemo(() => data
    && [
      {name: 'Aligned', color: theme.dark ? '#99FA66' : '#79AF30', y: data.aligned},
      {name: 'Too High', color: theme.dark ? '#FFCC03' : '#CF790B', y: data.tooHigh},
      {name: 'Too Low', color: '#1A69D2', y: data.tooLow},
      !(data.aligned + data.tooHigh + data.tooLow) && {name: 'No Risk Alerts', color: '#797B83', y: 1},
    ], [data]);

  if (!formattedData) {
    return <LoadingSpinner/>;
  }
  return <Row height={'100px'}
              alignSubRow={'stretch'}
              alignItems={'stretch'}
              layout={{grow: 1}}>
    <Pie data={formattedData}
         table={{
           defaultSort: {
             column: 'y',
             desc: true,
           },
           columns: [
             {
               title: 'Risk Status',
               dataPoint: 'name',
               type: 'text',
               render: colorRender,
               minWidth: 120,
               isSortable: true,
               verticalAlign: true,
             },
             {
               title: 'Households',
               dataPoint: 'y',
               type: 'number',
               minWidth: 90,
               isSortable: true,
             },
           ],
         }}
         hideLegend={!(data.aligned + data.tooHigh + data.tooLow)}
         sliceAction={slice => history.push(`/analyze/containers/${containerID}/risk/status?${buildQueryContext(
           context,
           {riskStatus: slice.name}
         )}`)}
         centerAction={() => history.push(`/analyze/containers/${containerID}/risk/status?${buildQueryContext(
           context,
           {dataSet: formattedData}
         )}`)}
    />
  </Row>;
};

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default withTheme(connect(null, mapDispatchToProps)(RiskGraph));

RiskGraph.propTypes = {
  openModal: PropTypes.func,
  containerID: PropTypes.number.isRequired,
  theme: PropTypes.object,
};
